import { NumericFormat, NumericFormatProps } from "react-number-format";

import { forwardRef } from "react";

interface CustomProps {
  onChange: (event: { target: { name: string; value: number } }) => void;
  name: string;
}

export const NumericFormatCustom = forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.floatValue || 0,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  }
);
